import { CloudSyncOutlined } from '@ant-design/icons';
import { Button, Flex, Layout } from 'antd';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { type AppView, navigationItems } from '@/app/shell/navigation';
import { APP_ROUTE_VIEWS } from '@/app/shell/routes';
import { navigationMessages } from './messages';

export function FixedBottomNavigation({ activeView }: { activeView: AppView }) {
  const intl = useIntl();
  return (
    <Layout.Footer
      style={{
        background: '#f5f5f5',
        bottom: 0,
        left: 0,
        padding: '12px 16px calc(12px + env(safe-area-inset-bottom))',
        position: 'fixed',
        right: 0,
        zIndex: 10,
      }}
    >
      <Flex gap="small" justify="center" wrap>
        {navigationItems.map(item => (
          <NavLink key={item.id} exact={item.path === '/'} to={item.path}>
            <Button
              icon={item.id === APP_ROUTE_VIEWS.sync ? <CloudSyncOutlined /> : undefined}
              type={activeView === item.id ? 'primary' : 'default'}
            >
              {intl.formatMessage(navigationMessages[item.id])}
            </Button>
          </NavLink>
        ))}
      </Flex>
    </Layout.Footer>
  );
}
